import { TypeService } from '../../Global/services/typeService';

export enum MapTileTypes {
    DEFAULT = 'DEFAULT',
    SATELLITE = 'SATELLITE',
}

export interface MapTileParams {
    tile: string;
    name: string;
    value: number; // qmsId
    img: string;
    id: string; // идентификатор базового слоя в системе ng
}

interface MapTile {
    [value: string]: MapTileParams;

    DEFAULT: MapTileParams;
    SATELLITE: MapTileParams;
}

const MAP_TILE: MapTile = {
    DEFAULT: {
        id: '1',
        value: 448,
        name: 'Схема',
        tile: 'DEFAULT',
        img: 'assets/images/svg/default-layer.svg',
    },
    SATELLITE: {
        id: '2',
        value: 2669,
        name: 'Спутник',
        tile: 'SATELLITE',
        img: 'assets/images/svg/satellite-layer.svg',
    },
};

export default MAP_TILE;

export const MapTileType = TypeService.createEnum<MapTileTypes>(MapTileTypes, 'MapTileTypes');
